<template>
  <div class="homeBody">
    <!-- 首页头部blanner -->
    <CustomerHome />
    <div class="our-blog">
      <el-row :gutter="20">
        <el-col :span="4">
            <h3>{{ $t('Industry.name') }}</h3>
            <p class="blog-p1">{{ $t('Industry.desc') }}</p>
        </el-col>
        <el-col :md="4" :sm="6" :xs="8">
          <el-card :body-style="{ padding: '0px' }" shadow="always">
            <div class="blog-agile">
              <div class="hover01 column">
                <figure>
                  <img src="../assets/img/blog-img1.jpg" alt="w3layouts" style="width: 100%; height: 12.6rem; z-index: 1;">
                </figure>
              </div>
              <div style="padding: 10px;">
                <a @click="handleProClick()"  class="blogimg-w3lh"><h4>{{ $t('Industry.title_1') }}</h4></a>
                <!-- <p class="blog-p2">{{ $t('Industry.desc_1') }}</p> -->
                <a @click="handleProClick()" class="blogimg-agile">
                  <p>Read More</p>
                  <span class="fa fa-angle-double-right" aria-hidden="true"></span>
                </a>
              </div>
            </div>
          </el-card>
        </el-col>
        <el-col :md="4" :sm="6" :xs="8">
          <el-card :body-style="{ padding: '0px' }" shadow="hover">
            <div class="blog-agile">
              <div class="hover01 column">
                <figure>
                  <img src="../assets/img/blog-img2.jpg" alt="w3layouts" style="width: 100%; height: 12.6rem; z-index: 1;">
                </figure>
              </div>
              <div style="padding: 10px;">
                <a @click="handleProClick()" class="blogimg-w3lh"><h4>{{ $t('Industry.title_2') }}</h4></a>
                <!-- <p class="blog-p2">{{ $t('Industry.desc_2') }}</p> -->
                <a @click="handleProClick()" class="blogimg-agile">
                  <p>Read More</p>
                  <span class="fa fa-angle-double-right" aria-hidden="true"></span>
                </a>
              </div>
            </div>
          </el-card>
        </el-col>
        <el-col :md="4" :sm="6" :xs="8">
          <el-card :body-style="{ padding: '0px' }" shadow="hover">
            <div class="blog-agile">
              <div class="hover01 column">
                <figure>
                  <img src="../assets/img/blog-img3.jpg" alt="w3layouts" style="width: 100%; height: 12.6rem; z-index: 1;">
                </figure>
              </div>
              <div style="padding: 10px;">
                <a @click="handleProClick()"  class="blogimg-w3lh"><h4>{{ $t('Industry.title_3') }}</h4></a>
                <!-- <p class="blog-p2">{{ $t('Industry.desc_3') }}</p> -->
                <a @click="handleProClick()"  class="blogimg-agile">
                  <p>Read More</p>
                  <span class="fa fa-angle-double-right" aria-hidden="true"></span>
                </a>
              </div>
            </div>
          </el-card>
        </el-col>
        <el-col :md="4" :sm="6" :xs="8">
          <el-card :body-style="{ padding: '0px' }" shadow="hover">
            <div class="blog-agile">
              <div class="hover01 column">
                <figure>
                  <img src="../assets/img/blog-img4.jpg" alt="w3layouts" style="width: 100%; height: 12.6rem; z-index: 1;">
                </figure>
              </div>
              <div style="padding: 10px;">
                <a @click="handleProClick()"  class="blogimg-w3lh"><h4>{{ $t('Industry.title_4') }}</h4></a>
                <!-- <p class="blog-p2">{{ $t('Industry.desc_4') }}</p> -->
                <a @click="handleProClick()"  class="blogimg-agile">
                  <p>Read More</p>
                  <span class="fa fa-angle-double-right" aria-hidden="true"></span>
                </a>
              </div>
            </div>
          </el-card>
        </el-col>
        <el-col :md="4" :sm="6" :xs="8">
          <el-card :body-style="{ padding: '0px' }" shadow="hover">
            <div class="blog-agile">
              <div class="hover01 column">
                <figure>
                  <img src="../assets/img/blog-img5.jpg" alt="w3layouts" style="width: 100%; height: 12.6rem; z-index: 1;">
                </figure>
              </div>
              <div style="padding: 10px;">
                <a @click="handleProClick()" class="blogimg-w3lh"><h4>{{ $t('Industry.title_5') }}</h4></a>
                <!-- <p class="blog-p2">{{ $t('Industry.desc_5') }}</p> -->
                <a @click="handleProClick()"  class="blogimg-agile">
                  <p>Read More</p>
                  <span class="fa fa-angle-double-right" aria-hidden="true"></span>
                </a>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>

    <!-- 新闻资讯 -->
    <div class="news">
      <el-row :gutter="0" style="height: 400px;">
        <el-col :span="7" class="news-left" >
          <NewsHome />
          <!-- <img :src="require('../assets/img/blog-img1.jpg')" alt="w3layouts"/> -->
        </el-col>
        <el-col :span="10" style="max-height: 400px;">
          <div class="container">
            <el-row class="newRow">
              <el-col :span="16" >
                <h3 class="title">{{ $t('homeNews.CompanyNews') }}</h3>
              </el-col>
              <el-col :span="8" class="more">
                <a @click="handleNews" style="color:#0D6EFD">{{ $t('public.more') }}</a>
                <span class="fa fa-angle-double-right" aria-hidden="true" style="color: #0d6efd;margin-left: 0px"></span>
              </el-col>
            </el-row>
            <div class="table">
              <ul class="new-comp">
                <li v-for="(item ,index) in homeNews" :key="index">
                  <a @click="handleClick(item.newsId)" id="n1">{{(item.newsTitle)|ellipsis(20)}}</a><a id="n2">{{ item.createdTime }}</a>
                </li>
              </ul>
            </div>
          </div>
        </el-col>
        <el-col :span="7" >
          <div class="container">
            <el-row class="newRow">
              <el-col :span="16">
                <h3 class="title">{{ $t('homeNews.PolicyInfo') }}</h3>
              </el-col>
              <el-col :span="8" class="more">
                <a @click="handleNews" style="color:#0D6EFD">{{ $t('public.more') }}</a>
                <span class="fa fa-angle-double-right" aria-hidden="true" style="color: #0d6efd;margin-left: 0px"></span>
              </el-col>
            </el-row>
            <div class="table">
              <ul class="new-comp">
                <li v-for="(item ,index) in homeStatute" :key="index">
                  <a @click="handleClick(item.newsId)" id="n1">{{(item.newsTitle)|ellipsis(10)}}</a><a id="n2">{{ item.createdTime }}</a>
                </li>

              </ul>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 联系我们 -->
    <div class="contact-us">
      <h3 class="text-center">联系我们</h3>
      <div class="container">
        <div class="row">
          <div class="col-lg-6 col-md-6 col-sm-6 contact-us-w3ls">
            <div class="contact-info">
              <p class="contact-us-p1">
                <a href="mailto:email@example.com">
                  <span class="fa fa-envelope-o" aria-hidden="true"></span>
                  frank.shi@jinhui-ncm.cn
                </a>
              </p>
            </div>
             <div class="contact-info">
              <p class="contact-us-p1"><span class="fa fa-volume-control-phone" aria-hidden="true"></span>+86-25-52752901</p>
            </div>
            <div class="contact-info">
              <p class="contact-us-p1"><span class="fa fa-map-marker" aria-hidden="true"></span>江苏省南京市江宁区科建路29号有志大厦B1座</p>
            </div>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-6 contact-us-w3ls" style="padding-left: 130px">
            <div class="contact-info">
              <p class="contact-us-p1">
                <a href="mailto:email@example.com">
                  <span class="fa fa-envelope-o" aria-hidden="true"></span>
                  chuang.yin@jinhui-ncm.cn
                </a>
              </p>
            </div>
             <div class="contact-info">
              <p class="contact-us-p1"><span class="fa fa-volume-control-phone" aria-hidden="true"></span>18052028910</p>
            </div>
            <div class="contact-info">
              <p class="contact-us-p1"><span class="fa fa-user" aria-hidden="true"></span>周经理</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomerHome from '../components/swiper/Customer_Home.vue'
import NewsHome from '../components/swiper/News_Home.vue'
import constant from '../constant/constant'
export default {
  components: { NewsHome, CustomerHome },
  data() {
    return {
      homeNews: [],
      homeStatute: []
    }
  },
  computed:{
    constant() {
      return constant;
    }
  },
  created() {
    this.handleSearchNews()
  },
  methods: {
    handleProClick() {
      this.$router.push(`/Products`);
    },
    handleClick(id) {
      this.$router.push(`/newsDetail/${id}`);
    },
    handleNews() {
      this.$router.push(`/News`);
    },
    handleSearchNews() {
      this.$axios.get('/api/news/findNewsPageList', {newsType: 0, pageNumber: 1, pageSize: 10}).then(res => {
        if (res.data.code = 200) {
          debugger
          this.homeNews = res.data.result.records || []
        }
      });
      this.$axios.get('/api/news/findNewsPageList',{newsType: 1,pageNumber: 1, pageSize: 10}).then(res => {
        if (res.data.code = 200) {
          this.homeStatute = res.data.result.records || []
        }
      });
    }
  }
}
</script>

<style scoped>
  .homeBody {
  }
  .our-blog {
	padding:100px 30px;
	background:url(../assets/img/blog-img.jpg);
	background-repeat:no-repeat;
	background-position:center;
	background-attachment:fixed;
	background-size:100% 100%;
	-webkit-background-size:100% 100%;
	-moz-background-size:100% 100%;
	-o-background-size:100% 100%;
	-moz-background-size:100% 100%;
	-ms-background-size:100% 100%;
}

a {
  text-decoration:none !important
}
.desc {
  font-size: 0.9rem;
}

/* .our-blog img:hover {
  height: 12.6rem;
  transform: scale(1.4)
} */
.our-blog .el-col{
  margin-top: 10px;
}
.our-blog h3 {
	font-size:30px;
	font-weight:normal;
	padding:20px 0;
	font-family: 'Viga', sans-serif;
	color:#fff;
}
.our-blog p.blog-p1 {
	font-size:16px;
	font-weight:normal;
	line-height:35px;
	padding:10px 0;
	color:#fff;
}
.our-blog .blog-agile {
	opacity:0.8;
	background-color:#1a1c28;
    text-align: center;
    padding:0;
	color:#fff;
	transition:all 0.7s ease-in-out;
	-webkit-transition:all 0.7s ease-in-out;
	-moz-transform:all 0.7s ease-in-out;
	-o-transform:all 0.7s ease-in-out;
	-ms-transition:all 0.7s ease-in-out;
}
.our-blog .blog-agile:hover {
	background-color:#fff;
	color:#000;
	opacity:1;
}
.our-blog .blog-agile a.blog-w3lh {
	padding: 25px 0 15px;
}
.our-blog .blog-agile a.blogimg-w3lh {
  font-weight:normal;
  font-family: 'Viga', sans-serif;
	color:#F42727;
	display:block;
	padding:5px 0;
}
.our-blog .blog-agile a.blogimg-w3lh h4 {
    font-size: 1.2em;
}
.our-blog .blog-agile p.blog-p2 {
	font-size:16px;
	font-weight:normal;
	line-height:25px;
	padding:0 0px 0px;
}
.our-blog .blog-agile a.blogimg-agile {
	padding:10px;
	font-family: 'Viga', sans-serif;
	background-color:#2c94c7;
	width:100%;
	display:block;
	position:relative;
	transition:all 0.7s ease-in-out;
	-webkit-transition:all 0.7s ease-in-out;
	-moz-transform:all 0.7s ease-in-out;
	-o-transform:all 0.7s ease-in-out;
	-ms-transition:all 0.7s ease-in-out;
}
.our-blog .blog-agile a.blogimg-agile p {
    margin:0px;
    text-align: left;
    margin-left: 10px;
    color: #fff;
    font-size: 18px;
}
 .our-blog .blog-agile a.blogimg-agile span.fa {
    position: absolute;
    background-color: #1E688C;
    color: #fff;
    right: 0px;
    font-size: 30px;
    width: 50px;
    line-height: 47px;
    padding-left: 2px;
    height: 47px;
    text-align: center;
    top: 0px;
    transition: all 0.7s ease-in-out;
    -webkit-transition: all 0.7s ease-in-out;
    -moz-transform: all 0.7s ease-in-out;
    -o-transform: all 0.7s ease-in-out;
    -ms-transition: all 0.7s ease-in-out;
}
.our-blog .blog-agile a.blogimg-agile:hover {
	background-color:#ffb400;
}
.our-blog .blog-agile a.blogimg-agile span.fa:hover {
	background-color:#f1600f;
}

figure {
	width:100%;
	height:100%;
	margin: 0;
	padding: 0;
	background: #fff;
	overflow: hidden;
}
.hover01 figure img {
	-webkit-transform: scale(1);
	transform: scale(1);
	-webkit-transition: .3s ease-in-out;
	transition:all 0.7s ease-in-out;
	-webkit-transition:all 0.7s ease-in-out;
	-moz-transform:all 0.7s ease-in-out;
	-o-transform:all 0.7s ease-in-out;
	-ms-transition:all 0.7s ease-in-out;
}
.hover01 figure:hover img {
	-webkit-transform: scale(1.5);
	transform: scale(1.5);
}
.news {
  padding: 50px 25px;
  width: 100%;
  height: 450px;
}
.news .el-row {
  height: 100%;
}
.news .el-col {
  height: 100%;
}
.news img.news-left{
  padding: 10px;
  width: 100%;
  height: 100%;
}
.news h3.title {
	font-size:22px;
	font-weight:normal;
  text-align: left;
	padding-bottom:3px;
	font-family: 'Viga', sans-serif;
	color:#224b8f;
}
.news .container .more {
	font-size:16px;
	font-weight:normal;
  text-align: right;
	padding-bottom:3px;
	font-family: 'Viga', sans-serif;
}
.news .container .table {
	font-size:16px;
  max-height: 400px;
	font-family: 'Viga', sans-serif;
}
.news .container .newRow {
  border-bottom: 0.22rem solid #ececec;
}
.news .new-comp {
  padding-left: 5px;
}

.news .new-comp li{
  list-style:none;
  clear:both;
  border-bottom:1px dashed #ccc;
  height:32px;
  color:#2c94c7;
  font-size: 15px;
  display:block
}
.news .new-comp li a#n1{
  text-decoration:none;
  float:left;
}

.news .new-comp li a#n2{
  text-decoration:none;
  float:right;
  color:#999;
  display:block
}
.news .new-comp li a#n1:hover{
  text-decoration:underline;
}

.news .new-comp li a#n2:hover{
  text-decoration:none;
}

.news p.text-center {
	font-size:16px;
	font-weight:normal;
	line-height:35px;
	padding-bottom:50px;
}
.news h4 {
    font-size: 25px;
    font-weight: normal;
    padding: 20px 0;
    text-align: center;
	font-family: 'Viga', sans-serif;
	color:#FF7373;
}
.news p.info-agile {
    font-size: 16px;
    font-weight: 400;
    text-align: center;
    line-height: 35px;
    padding: 0 30px;
}


.our-info {
  padding: 150px 45px 45px 50px;
  width: 100%;
}

.contact-us {
  margin-top: 50px;
  padding: 90px 180px 100px;
	background:url(../assets/img/bg_our.jpg);
	background-repeat:no-repeat;
	background-position:center;
	background-attachment:fixed;
	background-size:100% 100%;
	-webkit-background-size:100% 100%;
	-moz-background-size:100% 100%;
	-o-background-size:100% 100%;
	-moz-background-size:100% 100%;
	-ms-background-size:100% 100%;
	text-align:center;
  color: #fff;
}
.contact-us h3.text-center {
	font-size:34px;
	font-weight:normal;
	color:#fff;
  padding-bottom: 50px;
	font-family: 'Viga', sans-serif;
}
.contact-us p.text-center {
    font-size: 16px;
    font-weight: normal;
    padding-bottom: 50px;
    line-height: 35px;
}

.contact-us .contact-info {
  text-align: left;
}

.contact-us .contact-info  a {
	color:#fff;
	font-size:18px;
	font-weight:normal;
}
.contact-us .contact-info  a  span.fa , .contact-us .contact-info  span.fa {
	vertical-align:middle;
	color:#ffb400;
	font-size:25px;
	margin-right:10px;
}
.contact-us .contact-info  p.contact-us-p1 {
	font-size:17px;
	color:#fff;
	font-weight:normal;
}
ul.social-icons {
	padding:30px 0 0;
}
ul.social-icons li {
	display:inline;
}
ul.social-icons li a i.fa {
    font-size: 20px;
    color:#ffb400;
    width: 60px;
    height: 60px;
    text-align: center;
    vertical-align: middle;
    border: 1px solid #ffb400;
    line-height: 53px;
    margin-right: 7px;
}
ul.social-icons li a i.fa.fa-google-plus {
    font-size: 17px!important;
}
.contact-us ul.social-icons li a i.fa:hover {
    -webkit-animation: spin 2s linear infinite;
	animation: spin 2s linear infinite;
	-moz-animation: spin 2s linear infinite;
	-o-animation: spin 2s linear infinite;
	-ms-animation: spin 2s linear infinite;
}

figure {
	width:100%;
	height:100%;
	margin: 0;
	padding: 0;
	background: #fff;
	overflow: hidden;
}
.hover01 figure img {
	-webkit-transform: scale(1);
	transform: scale(1);
	-webkit-transition: .3s ease-in-out;
	transition:all 0.7s ease-in-out;
	-webkit-transition:all 0.7s ease-in-out;
	-moz-transform:all 0.7s ease-in-out;
	-o-transform:all 0.7s ease-in-out;
	-ms-transition:all 0.7s ease-in-out;
}
.hover01 figure:hover img {
	-webkit-transform: scale(1.5);
	transform: scale(1.5);
}
@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>



// WEBPACK FOOTER //
// src/views/Home.vue